import Settings from "@/pages/Settings";
export default function ProSettings() { return <Settings />; }
